import ConfirmationModalContainer from 'components/ConfirmationModalContainer';

import orgService from "services/Auth.Organization.service";
import storeTagService from "services/Auth.StoreTag.service";
import storeService from "services/Auth.Store.service";

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { organizationType } from 'const/nuclias/organization';
import { has } from "lodash"

const OrgManagementDeleteModal = ({
  modalStatus,
  handleModals,
  submitModal
}) => {
  const { t } = useTranslation();
  const [modalTitle, setModalTitle] = useState({});
  const editObj = modalStatus.delete.editObj;

  const init = () => {
    const tmp = {}
    switch (editObj.orgType) {
      case organizationType.si:
        tmp.title = 'c4fe0acb34'
        tmp.desc = `${t('037904d244')}`
        break
      case organizationType.org:
        tmp.title = '19dc1dd107'
        tmp.desc = `${t('d8ca9a3256')} <br/> ${t('9089dd4fa4')} <br/> ${t('d2850dcdad')}`
        break
      case organizationType.tag:
        tmp.title = 'e4e083d139'
        tmp.desc = `${t('b709c3f594')} <br/> ${t('dcc19d3201')} <br/> ${t('d2850dcdad')}`
        break
      case organizationType.site:
        tmp.title = '47f0cc1620'
        tmp.desc = `${t('4253b7aabe')} <br/> ${t('012c531a4e')} <br/> ${t('d2850dcdad')}`
        break
      default:
        console.debug('orgType not found')
    }
    setModalTitle(tmp)
  }

  const closeModal = () => {
    handleModals({ modal: 'delete', status: false })
  }

  const submit = async () => {
    try {
      let res = null
      if (editObj.orgType === organizationType.si || editObj.orgType === organizationType.org)
        res = await orgService.asyncDelete(editObj.id)
      else if (editObj.orgType === organizationType.tag)
        res = await storeTagService.asyncDeleteTag(editObj.id)
      else
        res = await storeService.asyncDeleteTag(editObj.id)

      if (res.error) {
        submitModal(res);
      } else {
        const action = {}
        if (editObj.orgType === organizationType.org && has(editObj, 'parentPage')) {
          if (editObj.parentPage === 'treeView') {
            action.exitPage = true
          }
        }
        submitModal(action)
      }
    } catch (error) {
      submitModal({ error });
    } finally {
      closeModal()
    }

  }

  useEffect(() => {
    init()
  }, [modalStatus?.delete?.status]);

  return (
    <ConfirmationModalContainer
      modalWidthType="modal-400px"
      title={modalTitle?.title}
      description={modalTitle?.desc}
      openModal={modalStatus.delete.status}
      closeModal={() => closeModal()}
      onConfirm={() => { submit() }}
    />
  );
};

export default OrgManagementDeleteModal;
